import "./upload.css";
export const STORAGE_ERROR = "No se pudo subir el archivo.";
export const NETWORK_ERROR = "No hay conexión con el servidor.";
export const NETWORK_BATCH_SUFFIX = "La carga no se confirmó; revisa la lista.";
export const AUTH_ERROR = "Tu cuenta no tiene permiso para cargar archivos.";
export const SERVER_ERROR = "El servidor no pudo procesar la carga.";
export const GENERIC_ERROR = "No se pudo completar la carga.";
export const INVALID_QUERY =
  "No se cargó ningún colaborador. Pudieron crearse dependencias; vuelve a cargar el archivo.";
export const INVALID_EXTENSION =
  "Solo se permiten archivos Excel (.xlsx o .xls).";
export const NO_VALID_ROWS =
  "El archivo no tiene ninguna fila válida para cargar.";
export const UNEXPECTED_SUCCESS =
  "La carga terminó, pero no se pudo mostrar el resultado. Revisa la lista.";
export const REFRESH_FAILED =
  "La carga se completó, pero la tabla no pudo actualizarse. Recarga la sección.";
export const REFRESH_FAILED_WITH_DEPENDENCIES =
  "La carga se completó, pero la tabla y la lista de dependencias no pudieron actualizarse. Recarga la sección.";
export const LARGE_FILE_NOTICE =
  "La carga puede tardar varios minutos; no cierres la ventana";

const ROW_ERRORS_LIMIT = 20;
const SCROLL_STYLE = "max-height: 260px; overflow-y: auto; text-align: left;";

export function escapeHtml(value) {
  return String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function largeNoticeHtml(show) {
  return show
    ? `<p style="margin-top: 12px;"><b>${escapeHtml(LARGE_FILE_NOTICE)}</b></p>`
    : "";
}

export function errorDialog(text) {
  return { icon: "error", text, confirmButtonText: "Entendido" };
}

export function noticeDialog(text, icon) {
  return { icon, text, confirmButtonText: "Entendido" };
}

export function largeFileDialog() {
  return {
    icon: "info",
    text: LARGE_FILE_NOTICE,
    showCancelButton: true,
    confirmButtonText: "Continuar",
    cancelButtonText: "Cancelar carga"
  };
}

export function columnErrorsDialog(columnErrors) {
  const order = [];
  const groups = {};
  columnErrors.forEach(function(item) {
    if (!groups[item.type]) {
      groups[item.type] = [];
      order.push(item.type);
    }
    groups[item.type].push(item);
  });
  const blocks = order.map(function(type) {
    return groups[type]
      .map(function(item) {
        const columns = Array.isArray(item.columns) ? item.columns : [];
        return `<p style="margin-top: 8px;"><b>${escapeHtml(
          item.error
        )}</b></p><p>${escapeHtml(columns.join(", "))}</p>`;
      })
      .join("");
  });
  return {
    icon: "error",
    title: "El archivo tiene errores en las columnas",
    html: `<div style="${SCROLL_STYLE}">${blocks.join("")}</div>`,
    confirmButtonText: "Entendido"
  };
}

export function rowErrorsHtml(rowErrors, limit) {
  const max = limit || ROW_ERRORS_LIMIT;
  const lines = rowErrors.slice(0, max).map(function(item) {
    const parts = [];
    if (item && item.row != null) parts.push(`Fila ${escapeHtml(item.row)}`);
    if (item && item.column) parts.push(escapeHtml(item.column));
    const head = parts.join(" · ");
    const detail = item && item.error ? escapeHtml(item.error) : "";
    if (head && detail) return `${head}: ${detail}`;
    return head || detail;
  });
  let html = lines.join("<br>");
  if (rowErrors.length > max) {
    html += `<br>y ${rowErrors.length - max} más`;
  }
  return `<div style="${SCROLL_STYLE}">${html}</div>`;
}

export function rowErrorsConfirmDialog(rowErrors, filas, withLargeNotice) {
  return {
    icon: "warning",
    title: "Hay filas con errores",
    html: `<p><b>Se cargarán ${escapeHtml(filas.validas)} de ${escapeHtml(
      filas.total
    )} filas</b></p>${rowErrorsHtml(rowErrors, ROW_ERRORS_LIMIT)}${largeNoticeHtml(
      withLargeNotice
    )}`,
    showCancelButton: true,
    confirmButtonText: `Sí, cargar ${escapeHtml(filas.validas)} filas`,
    cancelButtonText: "Cancelar carga"
  };
}

export function noValidRowsDialog(rowErrors) {
  return {
    icon: "error",
    title: NO_VALID_ROWS,
    html: rowErrors.length ? rowErrorsHtml(rowErrors, ROW_ERRORS_LIMIT) : "",
    confirmButtonText: "Entendido"
  };
}

export function newDependenciesDialog(dependenciasNuevas, withLargeNotice) {
  const count = dependenciasNuevas.length;
  const items = dependenciasNuevas
    .map(function(item) {
      const name = escapeHtml(item.nombreDependencia);
      const original =
        item.encabezado != null &&
        String(item.encabezado).replace(/\s+/g, " ").trim() !==
          item.nombreDependencia
          ? `<span class="cl-dep-source">Columna en el archivo: «${escapeHtml(
              item.encabezado
            )}»</span>`
          : "";
      return `<li class="cl-dep-item"><span class="cl-dep-icon"><i class="material-icons">account_tree</i></span><span class="cl-dep-text"><span class="cl-dep-name">${name}</span>${original}</span></li>`;
    })
    .join("");
  const large = withLargeNotice
    ? `<p class="cl-dep-notice"><i class="material-icons">schedule</i><span>${escapeHtml(
        LARGE_FILE_NOTICE
      )}.</span></p>`
    : "";
  const title =
    count === 1
      ? "Se detectó 1 dependencia nueva"
      : `Se detectaron ${count} dependencias nuevas`;
  return {
    title,
    html: `<p class="cl-dep-lead">El archivo trae columnas que este proceso todavía no tiene. Se crearán como dependencias para clasificar a los colaboradores.</p><ul class="cl-dep-list">${items}</ul>${large}`,
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText:
      count === 1
        ? "Crear la dependencia y continuar"
        : `Crear ${count} dependencias y continuar`,
    cancelButtonText: "Cancelar carga",
    customClass: {
      popup: "cl-dep-popup",
      title: "cl-dep-title",
      htmlContainer: "cl-dep-body",
      actions: "cl-dep-actions",
      confirmButton: "cl-dep-confirm",
      cancelButton: "cl-dep-cancel"
    },
    buttonsStyling: false
  };
}

function summaryText(result) {
  return `Carga completada: ${escapeHtml(result.creados)} creados, ${escapeHtml(
    result.actualizados
  )} actualizados, ${escapeHtml(result.dependenciasCreadas.length)} dependencias creadas`;
}

function createdNames(result) {
  return result.dependenciasCreadas
    .map(function(item) {
      return escapeHtml(item && item.nombre);
    })
    .join(", ");
}

export function successMessage(result) {
  const names = createdNames(result);
  return result.dependenciasCreadas.length > 0
    ? `${summaryText(result)}: ${names}`
    : summaryText(result);
}

export function successWithErrorsDialog(result) {
  const names =
    result.dependenciasCreadas.length > 0
      ? `<p>Dependencias creadas: ${createdNames(result)}</p>`
      : "";
  return {
    icon: "warning",
    title: "Carga completada con filas sin cargar",
    html: `<p>${summaryText(result)}</p>${names}<p style="margin-top: 8px;">Estas filas no se cargaron:</p>${rowErrorsHtml(
      result.errors,
      ROW_ERRORS_LIMIT
    )}`,
    confirmButtonText: "Entendido"
  };
}



// WEBPACK FOOTER //
// ./src/components/climan/upload/messages.js